import React from 'react';
import { useNavigate } from 'react-router-dom';
import SnapTradeConnect from '../components/SnapTradeConnect';

export default function Connect() {
  const navigate = useNavigate();
  return (
    <main className="min-h-screen bg-neutral-950 text-neutral-100 flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center space-y-6">
        <h1 className="text-3xl font-semibold">Connect your investment accounts</h1>
        <p className="text-neutral-400">
          ShrewdHedge uses SnapTrade to read holdings, transactions, and balances
          from Schwab, Fidelity, E*TRADE, Coinbase, Robinhood, and more. You can
          disconnect any time. Your access tokens are encrypted at rest.
        </p>
        <SnapTradeConnect
          label="Connect a brokerage"
          onConnected={() => navigate('/connect/pending', { replace: true })}
        />
        <p className="text-xs text-neutral-500">
          Sandbox: connect "Drivewealth" to see test holdings.
        </p>
      </div>
    </main>
  );
}
